import { Action, Selector, State, StateContext } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { EMPTY, Observable, catchError, finalize, tap } from 'rxjs';
import { ProfessionalServicesRecentSessionsService } from '@pages/professional-services/services/professional-services-recent-sessions.service';
import { LoadRecentSessions } from '@pages/professional-services/store/actions/professional-services-recent-sessions.actions';
import { RecentSession } from '@pages/professional-services/models/recent-sessions/recent-session.interface';

interface ProfessionalServicesRecentSessionsStateModel {
  recentSessions?: RecentSession[];
  loading: boolean;
  error: boolean;
}

@State<ProfessionalServicesRecentSessionsStateModel>({
  name: 'professionalServicesRecentSessions',
  defaults: {
    loading: false,
    error: false,
  },
})
@Injectable()
export class ProfessionalServicesRecentSessionsState {
  private readonly professionalServicesRecentSessionsService = inject(ProfessionalServicesRecentSessionsService);

  @Selector()
  static recentSessions(state: ProfessionalServicesRecentSessionsStateModel): RecentSession[] | undefined {
    return state.recentSessions;
  }

  @Selector()
  static loading(state: ProfessionalServicesRecentSessionsStateModel): boolean {
    return state.loading;
  }

  @Selector()
  static error(state: ProfessionalServicesRecentSessionsStateModel): boolean {
    return state.error;
  }

  @Action(LoadRecentSessions, { cancelUncompleted: true })
  loadProjectsCount(context: StateContext<ProfessionalServicesRecentSessionsStateModel>): Observable<RecentSession[]> {
    context.patchState({ loading: true, error: false });

    return this.professionalServicesRecentSessionsService.getRecentSessions().pipe(
      tap(recentSessions =>
        context.patchState({
          recentSessions,
          error: false,
        })
      ),
      catchError(() => {
        context.patchState({
          recentSessions: undefined,
          error: true,
        });
        return EMPTY;
      }),
      finalize(() => context.patchState({ loading: false }))
    );
  }
}
